import api from '@/apis/pa/pASalaryAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';
// Combo grid Tiền lương
export const useSalaryComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {extendFilter} = usefilterActionCombo();
  const {proxy} = getCurrentInstance();
  // func call api lấy dữ liệu combo
  const onSalaryComboboxLoadData = (payload, row, column) => {
    payload.sort = '';
    let extend = [{Field: 'ref_type', Value: 502}];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // func call api lấy dữ liệu combo có item Không chọn
  const onSalaryComboboxLoadDataHasNotSelect = (payload, ref_type, row, column) => {
    payload.sort = '';
    let extend = [{Field: 'ref_type', Value: ref_type}];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, res => {
      return [
        {
          ref_id: -1,
          description: 'Không chọn',
        },
        ...res,
      ];
    });
  };

  const comboboxLoadDataCustom = async (payload, entityApi, action, data, name, callBackFn) => {
    await entityApi[action](payload).then(result => {
      if (typeof callBackFn == 'function') {
        // bổ sung func cho phép dev custom dữ liệu combo
        result = callBackFn(result, payload);
      }
      data[name] = result;
    }).catch(err => {
      throw err;
    });
  };

  // config columns combo
  const salaryComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        dataField: 'description',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
    ],
    displayField: 'description',
    valueField: 'ref_id',
    queryMode: 'remote',
    dropdownWidth: 350,
    comboboxLoadData: onSalaryComboboxLoadData,
  };

  const onSalagovSalaryTableComboboxLoadData = async (payload, row, column, custom, action) => {
    try {
        payload.sort = '';
        let extend = [{}];
        payload.filter = extendFilter(payload.filter, extend);
        await comboboxLoadDataCustom(payload, api, action, comboboxDataRemote, column.dataField, custom?.callBackFn);
    } catch (ex) {
        throw ex; // Throw lỗi ra ngoài
    }
  };

  return {
    salaryComboConfig,
    onSalaryComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
    onSalaryComboboxLoadDataHasNotSelect,
    onSalagovSalaryTableComboboxLoadData,
  };
};
